export default __webpack_public_path__ + "static/media/1152.dfd3c912.png";